import { CREATE_ORDER_REQUEST, CREATE_ORDER_REQUEST_SUCCESS, CREATE_ORDER_REQUEST_FAILURE } from '../constants/create_order.constants';

const initialState = {
    loading: false,
    tab: null,
    date_type: '',
    date_from: null,
    date_to: null,
    transport_date_data: null,
    order_status: null,
    error: null,
};

export const Lead_transport = (state = initialState, action) => {
    switch (action.type) {
    case 'CHANGE_MAX_OPTRA_STATUS':
        return {
            ...state,
            order_status: action.payload,
        };
    case 'RESET_TRANSPORT_DATE_DATA':
        return {
            ...state,
            transport_date_data: null,
        };
    case CREATE_ORDER_REQUEST:
        return {
            ...state,
        };
    case CREATE_ORDER_REQUEST_SUCCESS:
        return {
            ...state,
            transport_date_data: action.payload,
            isTransportCreated: true,
        };
    case CREATE_ORDER_REQUEST_FAILURE:
        return {
            ...state,
            error: action.error,
        };
    case 'CHANGE_TRANSPORT_OPTIONS_TAB':
        return {
            ...state,
            tab: action.tab,
        };
    case 'SET_TRANSPORT_OPTIONS_DATE':
        return {
            ...state,
            date_from: action.date || action.date_from,
            date_to: action.date || action.date_to,
            date_type: action.date_type,
        };
    case 'SET_TRANSPORT_OPTIONS_TIME_FROM':
        if (state.date_from.length === 10) {
            state.date_from = `${state.date_from} ${action.date_from}`;
        } else {
            state.date_from = state.date_from.replace(/\s[0-9]{2}:[0-9]{2}$/, ` ${action.date_from}`);
        }
        return {
            ...state,
            date_from: state.date_from,
        };
    case 'SET_TRANSPORT_OPTIONS_TIME_TO':
        return {
            ...state,
            date_to: `${state.date_to} ${action.date_to}`,
        };
    case 'CLEAR_TRANSPORT_OPTIONS_DATE':
        return {
            ...state,
            date_from: null,
            date_to: null,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/transport_modal.reducers.js